<div class="layout-breadcrumb lg:px-12">
    <ul class="alineado-ultimo-elemento hidden-xs-down">
        <li><a routerLink=""><i class="pi pi-home"></i></a></li>
        <li><i class="pi pi-chevron-right"></i></li>
        <ng-template ngFor let-item let-last="last" [ngForOf]="items">
            <li>
                <a [routerLink]="item.routerLink" *ngIf="item.routerLink">{{item.label}}</a>
            <ng-container *ngIf="!item.routerLink">{{item.label}}</ng-container>
            </li>
            <li *ngIf="!last"><i class="pi pi-chevron-right"></i></li>
        </ng-template>
        <li style="text-align:right;right:0;" >
        </li>
    </ul>

    <div class="layout-breadcrumb lg:px-12">
        <div class="surface-section px-3 py-4 md:px-5 lg:px-7">
            <div class="flex align-items-start flex-column lg:flex-row lg:justify-content-between">
                <div class="flex align-items-start flex-column md:flex-row">
                    <!--<img src="assets/images/blocks/avatars/circle/avatar-f-1@2x.png" class="mr-5 mb-3 lg:mb-0" style="width:90px;height:90px" />-->
                    <div *ngIf="currentUser.organization">
                        <span class="text-900 font-medium text-3xl">
                            {{ title | uppercase }}
                            <p-button pRipple styleClass="p-button p-button-info"
                                        (click)="activarPopupSeleccionarEstablecimiento($event)"
                                        [disabled]="false"
                                        style="top:8px;">
                                  <i class="pi pi-map-marker {{ establishment ? '' : 'required-icon'}}"></i>
                                  <span>&nbsp;&nbsp;{{ establishment ? establishment.nombreComercial : 'Establecimiento...'}} | {{ emissionPointSelected ? emissionPointSelected.name + ' ' + emissionPointSelected.description  : 'N/A'}}</span>
                                  <span class="p-ink">
                                  </span>
                            </p-button>
                        </span>
                        <a pRipple (click)="ocultarAyuda(false)" title="Ayuda"><i class="pi pi-heart-fill text-2xl ml-4 text-yellow-500"></i></a>
                        <a pRipple (click)="displayqr=true;" title="Asistencia"><i class="pi pi-whatsapp text-2xl ml-4 text-green-500"></i></a>
                        <a pRipple (click)="displayqr=true;" title="Agendar turnos/citas"><span class="text-100 ml-4 text-orange-900">¿Necesitar agendar turno/citas para tu negocio? ¡Contactanos!</span></a>
                        <div class="flex align-items-center flex-wrap text-sm">
                            <div class="mr-5 mt-3">
                                <span class="font-medium text-500">{{currentUser.organization.initials}}</span>
                                <!--<div class="text-700 mt-2">333</div>-->
                            </div>
                            <div class="mr-5 mt-3" *ngIf="currentUser.organization.regimenRimpeTipo">
                                <span class="font-medium text-500">RIMPE {{currentUser.organization.regimenRimpeTipo}}</span>
                                <!--<div class="text-700 mt-2">333</div>-->
                            </div>
                            <div class="mr-5 mt-3" *ngIf="currentUser.organization.agenteRetencion">
                                <span class="font-medium text-500">AGENTE RETENCIÓN</span>
                                <!--<div class="text-700 mt-2">26</div>-->
                            </div>
                            <div class="mr-5 mt-3" *ngIf="currentUser.organization.contribuyenteEspecial">
                                <span class="font-medium text-500">CONTRIBUYENTE ESPECIAL {{currentUser.organization.contribuyenteEspecialNumeroResolucion}}</span>
                                <!--<div class="text-700 mt-2">17</div>-->
                            </div>
                            <div class="mr-5 mt-3" *ngIf="currentUser.organization.artesanoCalificado">
                                <span class="font-medium text-500">ARTESANO CALIFICADO {{currentUser.organization.artesanoCalificadoNumero}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex align-items-center flex-column md:flex-row">
                    <!-- dummy -->
                </div>
                <div class="flex align-items-end flex-column md:flex-row">
                    <p-selectButton [options]="ambientes" 
                                    [(ngModel)]="ambiente" 
                                    optionLabel="name" optionValue="value"
                                    (onOptionClick)="actualizarAmbiente($event)"
                                    class="p-button-rounded p-selectbutton-ambiente">
                    </p-selectButton>
                </div>
            </div>
            <div class="help-section" *ngIf="mostrarAyuda == true">
                <div class="flex lg:align-items-start flex-column lg:flex-row p-4 bg-blue-100 border-round border-1 border-blue-300">
                    <div class="flex align-items-start">
                        <i class="pi pi-check-circle text-blue-900 text-2xl mr-3"></i>
                        <div class="mr-3 flex lg:align-items-start flex-column lg:flex-row">
                            <div class="text-blue-900 font-medium mr-0 lg:mr-2 mb-2 lg:mb-0 line-height-3">Ayuda</div>
                            <p class="m-0 p-0 text-blue-700 line-height-3">{{ pageDescription }}</p>
                        </div>
                    </div>
                    <a pRipple (click)="display = true;"><i class="pi pi-file-pdf text-2xl ml-4 text-yellow-500"></i></a>
                    <a pRipple (click)="displayqr=true;" title="Asistencia"><i class="pi pi-whatsapp text-2xl ml-4 text-green-500"></i></a>
                    <a pRipple (click)="displayqr=true;" title="Agendar turnos/citas">¿Necesitar agendar turno/citas para tu negocio? ¡Contactanos!</a>
                    <div class="ml-auto">
                        <a pRipple class="inline-flex align-items-center justify-content-center ml-auto border-circle hover:bg-pink-50 no-underline cursor-pointer transition-colors transition-duration-150" style="width:1.5rem;height:1.5rem"
                           (click)="ocultarAyuda(true);">
                            <i class="pi pi-times text-pink-900"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div *ngIf="invoiceGlobal.puedeFacturarPorPlan && invoiceGlobal.mostrarAlertaRecarga">
                <div class="flex align-items-start p-4 bg-yellow-100 border-round border-1 border-yellow-300">
                    <i class="pi pi-exclamation-triangle text-yellow-900 text-2xl mr-3"></i>
                    <div class="mr-3">
                        <div class="text-yellow-900 font-medium text-xl mb-2 line-height-1">Atención</div>
                        <p class="m-0 p-0 text-yellow-700 mb-3 line-height-3"><strong>{{invoiceGlobal.maximoComprobantes - invoiceGlobal.numeroComprobantesEmitidos}}</strong>{{' '}}{{ invoiceGlobal.puedeFacturarPorPlan ? 'Comprobantes disponibles' : appConfig.ux.actions.recargar}}</p>
<!--                        <a class="font-medium text-yellow-900 hover:text-yellow-800 mr-4 no-underline cursor-pointer select-none transition-colors transition-duration-150"
                           (click)="recargarPlan($event);">Recargar plan</a>-->
                        <a pRipple class="font-medium text-yellow-900 hover:text-yellow-800 mr-4 no-underline cursor-pointer select-none transition-colors transition-duration-150" (click)="displayqr=true;" title="Recargar plan vía whatsapp">Recargar plan vía whatsapp <i class="pi pi-whatsapp text-2xl ml-4 text-green-500"></i></a>
<!--                        <a class="font-medium text-yellow-900 hover:text-yellow-800 no-underline cursor-pointer select-none transition-colors transition-duration-150"
                           (click)="invoiceGlobal.mostrarAlertaRecarga=false"
                           >Cerrar advertencia</a>-->
                    </div>
                    <div class="ml-auto">
                        <a pRipple class="inline-flex align-items-center justify-content-center ml-auto border-circle hover:bg-yellow-50 no-underline cursor-pointer transition-colors transition-duration-150" style="width:1.5rem;height:1.5rem"
                           (click)="invoiceGlobal.mostrarAlertaRecarga=false"
                           >
                            <i class="pi pi-times text-yellow-900"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p-dialog header="Ayuda" [(visible)]="display" modal="modal" showEffect="fade" [style]="" styleClass="help-dialog pdf-help">
    <div style="margin:0px;padding:0px;overflow:hidden;line-height: 1.5">
        <iframe [src]="safeSrc" height="100%" width="100%" style="overflow:hidden;width:100%;height:100%;" class="pdf-iframe"></iframe> 
    </div>
    <p-footer>
        <button type="button" pButton icon="pi pi-times" (click)="display=false" label="Cerrar" class="p-button-danger"></button>
    </p-footer>
</p-dialog>
<p-dialog header="Escanea para obtener asesoría Pro" [(visible)]="displayqr" modal="modal" showEffect="fade" [style]="" styleClass="help-dialog pdf-help">
    <div class="surface-ground px-2 py-4 md:px-4 lg:px-6">
        <div class="text-xl line-height-3 text-600 mb-3 text-center">Contadores expertos a tu servicio</div>
        <div class="flex justify-content-center flex-column lg:flex-row">
            <div class="shadow-2 p-4 mb-5 lg:mb-0 mr-0 lg:mr-5 surface-card">
                <img src="../assets/layout/images/qr/facturafacil-qr-02.png" class="mb-2 w-25rem"  />
                <div class="flex justify-content-between align-items-center">
                    <div class="pr-3">
                        <div class="text-xl text-900 font-medium mb-2">Andrea</div>
                        <div class="text-blue-600">Contadora</div>
                    </div>
                    <div class="flex flex-nowrap">
<!--                        <button pButton pRipple class="p-button-rounded p-button-text p-button-outlined p-button-plain mr-2" icon="pi pi-twitter"></button>
                        <button pButton pRipple class="p-button-rounded p-button-text p-button-outlined p-button-plain" icon="pi pi-github"></button>-->
                    </div>
                </div>
            </div>
            <div class="shadow-2 p-4 mb-5 lg:mb-0 mr-0 lg:mr-5 surface-card">
                <img src="../assets/layout/images/qr/facturafacil-qr-01.png" class="mb-2 w-25rem" />
                <div class="flex justify-content-between align-items-center">
                    <div class="pr-3">
                        <div class="text-xl text-900 font-medium mb-2">Alex</div>
                        <div class="text-blue-600">Contador</div>
                    </div>
                    <div class="flex flex-nowrap">
<!--                        <button pButton pRipple class="p-button-rounded p-button-text p-button-outlined p-button-plain mr-2" icon="pi pi-twitter"></button>
                        <button pButton pRipple class="p-button-rounded p-button-text p-button-outlined p-button-plain" icon="pi pi-github"></button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton icon="pi pi-times" (click)="displayqr=false" label="Cerrar" class="p-button-danger"></button>
    </p-footer>
</p-dialog>


<!-- Diálogo seleccionar establecimiento -->
<p-dialog header="Seleccionar el establecimiento" [(visible)]="mostrarSeleccionarEstablecimiento" 
          [modal]="true" showEffect="fade" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw', height: '600px'}"
          [transitionOptions]="'0ms'" (onHide)="mostrarSeleccionarEstablecimiento=false;">
    <app-establecimientos titulo="Local Comercial" 
                          [puntoEmisionSeleccionado]="emissionPointSelected"
                          [establecimientos]="establishments"
                          [requerido]="true"
                          [soloLectura]="false"
                          (onChange)="asignarPuntoEmision($event)"
                          ></app-establecimientos>
</p-dialog>
<!-- //Diálogo seleccionar establecimiento -->